export default "__VITE_ASSET__DfWTv5kO__"